import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useEntidadeContext } from '../../EntidadeContext';
import { useAlertModal } from '../../AlertModalContext';
import axios from 'axios';

const ICONS = {
  share:     'M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z',
  save:      'M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4',
  check:     'M5 13l4 4L19 7',
  link:      'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1',
};

const SvgIcon = ({ d, size = 14, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);

/* SVGs inline das marcas */
const InstagramSvg = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="url(#ig)" strokeWidth="2" />
    <circle cx="12" cy="12" r="4" stroke="url(#ig)" strokeWidth="2" />
    <circle cx="17.5" cy="6.5" r="1" fill="#e1306c" />
    <defs>
      <linearGradient id="ig" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse">
        <stop stopColor="#f09433" /><stop offset=".25" stopColor="#e6683c" />
        <stop offset=".5" stopColor="#dc2743" /><stop offset=".75" stopColor="#cc2366" />
        <stop offset="1" stopColor="#bc1888" />
      </linearGradient>
    </defs>
  </svg>
);

const FacebookSvg = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#1877f2">
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
  </svg>
);

const LinkedInSvg = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#0a66c2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const REDES = [
  {
    key: 'instagram_url',
    label: 'Instagram',
    placeholder: 'https://www.instagram.com/seuperfil',
    Icon: InstagramSvg,
    accent: '#e1306c',
    bg: '#fdf2f8',
    border: '#f9a8d4',
  },
  {
    key: 'facebook_url',
    label: 'Facebook',
    placeholder: 'https://www.facebook.com/suapagina',
    Icon: FacebookSvg,
    accent: '#1877f2',
    bg: '#eff6ff',
    border: '#bfdbfe',
  },
  {
    key: 'linkedin_url',
    label: 'LinkedIn',
    placeholder: 'https://www.linkedin.com/company/suaempresa',
    Icon: LinkedInSvg,
    accent: '#0a66c2',
    bg: '#eff6ff',
    border: '#bfdbfe',
  },
];

const inputBase = {
  flex: 1, padding: '9px 12px', borderRadius: '0 8px 8px 0',
  border: '1px solid #e5e7eb', borderLeft: 'none',
  fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontFamily: 'inherit',
  outline: 'none', backgroundColor: '#fff', boxSizing: 'border-box',
  transition: 'border-color .15s, box-shadow .15s',
};

const RedesSociaisTab = () => {
  const { currentEntidade, setCurrentEntidade } = useEntidadeContext();
  const { showAlertModal } = useAlertModal();

  const [formData, setFormData] = useState({ instagram_url: '', facebook_url: '', linkedin_url: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (currentEntidade) {
      setFormData({
        instagram_url: currentEntidade.instagram_url || '',
        facebook_url:  currentEntidade.facebook_url  || '',
        linkedin_url:  currentEntidade.linkedin_url  || '',
      });
      setIsChanged(false);
    }
  }, [currentEntidade]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setIsChanged(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.put(`/api/entidades/${currentEntidade.id}/redes-sociais`, formData);
      setCurrentEntidade(response.data.entidade);
      showAlertModal('Sucesso', 'Links das redes sociais atualizados!', 'success');
      setIsChanged(false);
    } catch {
      showAlertModal('Erro', 'Não foi possível salvar os links.', 'danger');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');`}</style>

      {/* HEADER */}
      <div style={{ background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', borderRadius: '14px', padding: '20px 24px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div style={{ width: '44px', height: '44px', borderRadius: '12px', backgroundColor: 'rgba(255,255,255,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <SvgIcon d={ICONS.share} size={22} color="#fff" stroke={1.8} />
        </div>
        <div>
          <div style={{ fontSize: '16px', fontWeight: '800', color: '#fff' }}>Redes Sociais</div>
          <div style={{ fontSize: `calc(12px * var(--font-scale))`, color: 'rgba(255,255,255,.7)' }}>Links exibidos no site e materiais da clínica</div>
        </div>
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit}>
        <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '16px' }}>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '22px', paddingBottom: '14px', borderBottom: '2px solid #f1f5f9' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '7px', background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SvgIcon d={ICONS.link} size={14} color="#fff" />
            </div>
            <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#1e3a5f' }}>Configure os links</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
            {REDES.map(({ key, label, placeholder, Icon, accent, bg, border }) => {
              const val = formData[key];
              const hasValue = val.trim().length > 0;
              return (
                <div key={key}>
                  <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.5px', display: 'block', marginBottom: '7px' }}>
                    {label}
                  </label>
                  <div style={{ display: 'flex', alignItems: 'stretch', borderRadius: '8px', border: `1px solid ${hasValue ? border : '#e5e7eb'}`, overflow: 'hidden', transition: 'border-color .2s', boxShadow: hasValue ? `0 0 0 3px ${accent}18` : 'none' }}>
                    {/* Ícone prefixo */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 14px', backgroundColor: hasValue ? bg : '#f9fafb', borderRight: `1px solid ${hasValue ? border : '#e5e7eb'}`, transition: 'background .2s' }}>
                      <Icon size={18} />
                    </div>
                    <input
                      type="url"
                      name={key}
                      value={val}
                      onChange={handleChange}
                      placeholder={placeholder}
                      style={{ ...inputBase, borderColor: 'transparent', boxShadow: 'none' }}
                      onFocus={e => { e.target.parentElement.style.borderColor = accent; e.target.parentElement.style.boxShadow = `0 0 0 3px ${accent}20`; }}
                      onBlur={e => { e.target.parentElement.style.borderColor = hasValue ? border : '#e5e7eb'; e.target.parentElement.style.boxShadow = hasValue ? `0 0 0 3px ${accent}18` : 'none'; }}
                    />
                    {/* Badge de preenchido */}
                    {hasValue && (
                      <div style={{ display: 'flex', alignItems: 'center', padding: '0 12px', backgroundColor: bg }}>
                        <span style={{ fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: accent, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <SvgIcon d={ICONS.check} size={11} color={accent} stroke={2.5} /> OK
                        </span>
                      </div>
                    )}
                  </div>
                  {/* Preview do link */}
                  {hasValue && (
                    <a href={val} target="_blank" rel="noopener noreferrer" style={{ fontSize: `calc(11px * var(--font-scale))`, color: accent, marginTop: '4px', display: 'inline-flex', alignItems: 'center', gap: '4px', textDecoration: 'none' }}>
                      <SvgIcon d={ICONS.link} size={10} color={accent} />
                      {val.length > 50 ? val.substring(0, 50) + '...' : val}
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* AÇÕES */}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            type="submit"
            disabled={isLoading || !isChanged}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              padding: '10px 24px', borderRadius: '10px', border: 'none',
              background: (isLoading || !isChanged) ? '#e5e7eb' : 'linear-gradient(135deg,#1e3a5f,#2563eb)',
              color: (isLoading || !isChanged) ? '#9ca3af' : '#fff',
              fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', fontFamily: 'inherit',
              cursor: (isLoading || !isChanged) ? 'not-allowed' : 'pointer',
            }}
          >
            {isLoading
              ? <><Spinner as="span" animation="border" size="sm" style={{ width: '13px', height: '13px', borderWidth: '2px' }} /> Salvando...</>
              : <><SvgIcon d={ICONS.save} size={13} color="#fff" /> Salvar Links</>
            }
          </button>
        </div>
      </form>
    </div>
  );
};

export default RedesSociaisTab;
